// LIBRARIES //
import React from 'react';
import { Summary } from '@yuhuinc/ui-library';
import styled from 'styled-components';
import { connect } from 'react-redux';
import moment from 'moment';
import startCase from 'lodash/startCase';

// HELPERS //
import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';

// ACTIONS //
import { inviteLead, getTenant } from 'actions/landlordTenantsActions';
import { setLoading, showInvitedDrawer } from '../store/actions';

const Body = styled.div`
  margin-bottom: 40px;
`;

const StyledText = styled.span`
  font-size: 16px;
  line-height: 20px;
`;

const canRemind = (invitationSentAt, status) => {
  if (status === 'inviting') return false;
  if (!invitationSentAt) return true;

  const sentAtDate = moment(invitationSentAt);

  return moment().startOf('day') > sentAtDate.add(7, 'days').startOf('day');
};

const InviteResident = ({
  residentData,
  reloadPageData,
  inviteLead,
  getTenant,
  loading,
  setLoading,
  showInvitedDrawer,
}) => {
  const inviteData = {
    title: getTranslatedString('residentDrawer.residentDetailTab.invite.title', {
      first_name: residentData.first_name,
    }),
    buttonText: getTranslatedString('residentDrawer.residentDetailTab.invite.button'),
    children: (
      <StyledText>
        {getTranslatedString('residentDrawer.residentDetailTab.invite.body', {
          first_name: residentData.first_name,
        })}
      </StyledText>
    ),
  };

  const remindDisabledData = {
    ...inviteData,
    buttonText: getTranslatedString('residentDrawer.residentDetailTab.remind.button'),
    children: (
      <StyledText>
        {getTranslatedString('residentDrawer.residentDetailTab.remindDisabled.body', {
          first_name: residentData.first_name,
          last_reminded_date: startCase(
            moment(residentData.invitation_sent_at).format('MMM D, YYYY')
          ),
          next_remind_date: startCase(
            moment(residentData.invitation_sent_at).add(7, 'days').format('MMM D, YYYY')
          ),
        })}
      </StyledText>
    ),
  };

  const remindData = {
    ...remindDisabledData,
    children: (
      <StyledText>
        {getTranslatedString('residentDrawer.residentDetailTab.remind.body', {
          first_name: residentData.first_name,
          last_reminded_date: startCase(
            moment(residentData.invitation_sent_at).format('MMM D, YYYY')
          ),
        })}
      </StyledText>
    ),
  };

  let summaryData = inviteData;

  if (residentData.invited) {
    summaryData = remindDisabledData;
  }

  if (residentData.invited && canRemind(residentData.invitation_sent_at)) {
    summaryData = remindData;
  }

  let buttonOnClick = async () => {
    try {
      setLoading(true);
      await inviteLead(residentData.lead_id);
      reloadPageData();
      getTenant(residentData.id, { all_maintenance_tickets: true }); // retrieves data for this drawer
      showInvitedDrawer();
      setLoading(false);
    } catch (e) {
      // do nothing
    }
  };
  return (
    <Body>
      <Summary
        {...summaryData}
        divider
        buttonColor={AccentColor()}
        buttonOnClick={buttonOnClick}
        buttonType="primary"
        buttonLoading={loading}
        disabled={!canRemind(residentData.invitation_sent_at, residentData.status)}
      />
    </Body>
  );
};

export default connect((store) => ({ loading: store.landlord.residentDrawer.loading }), {
  inviteLead,
  getTenant,
  setLoading,
  showInvitedDrawer,
})(InviteResident);
